import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { SUPPORTED_HUBS_REQUIRED_SCOPES } from '../constants';
import { hasScope } from '../utils/auth';
import { FEATURES } from 'collaboration-sidebar/constants/features';
export default function useHasSidebarPermission(t0) {
  "use memo";

  const $ = _c(4);
  const {
    appHub,
    enabledFeatures
  } = t0;
  let t1;
  bb0: {
    if (!enabledFeatures) {
      t1 = false;
      break bb0;
    }
    const hasComments = enabledFeatures.includes(FEATURES.COMMENTS) || enabledFeatures.includes(FEATURES.DEEP_COMMENTING);
    if (!hasComments) {
      t1 = true;
      break bb0;
    }
    if (!appHub) {
      t1 = false;
      break bb0;
    }
    if (Array.isArray(appHub)) {
      let t2;
      if ($[0] !== appHub) {
        t2 = appHub.find(_temp);
        $[0] = appHub;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = Boolean(t2);
      break bb0;
    }
    const t2 = SUPPORTED_HUBS_REQUIRED_SCOPES[appHub];
    let t3;
    if ($[2] !== t2) {
      t3 = hasScope(t2);
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t1 = t3;
  }
  return t1;
}
function _temp(hub) {
  return hasScope(SUPPORTED_HUBS_REQUIRED_SCOPES[hub]);
}